import { animeList } from "@/mocks/anime";
import AnimeCard from "./AnimeCard";

const hot = animeList.slice(0, 6);

export default function Featured() {
  return (
    <section id="hot" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3">
        <div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-fire-line"></i>
            本周热门
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            热门推荐 · 萌宠控都在看
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            按站内人气动态排序，狗狗主角、动物拟人、兽耳萌番一网打尽。
          </p>
        </div>
        <a
          href="#new"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors"
        >
          查看全部
          <i className="ri-arrow-right-line text-sm"></i>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {hot.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}